export default __webpack_public_path__ + "ca2cfaa6c7bac6e67fff0719d591cb74.svg";